import { render, staticRenderFns } from "./ReservationTrends.vue?vue&type=template&id=76804002&scoped=true"
import script from "./ReservationTrends.vue?vue&type=script&lang=js"
export * from "./ReservationTrends.vue?vue&type=script&lang=js"
import style0 from "./ReservationTrends.vue?vue&type=style&index=0&id=76804002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76804002",
  null
  
)

export default component.exports